var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"breadcrumb"}},[_c('Breadcrumbs',{directives:[{name:"show",rawName:"v-show",value:(_vm.path.length),expression:"path.length"}],attrs:{"root-el":_vm.rootEl,"path":_vm.path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }